// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7bf55781","239":"6c13f5a8","455":"6b447b8c"}[chunkId] + ".chunk.js";
};